import React, { useState } from "react";
import { Plus, WhatsappLogo } from "@phosphor-icons/react";
import { toast } from "sonner";
import { money, TYPE_LABEL, consultPriceUrl, isConsult } from "../lib/api";
import { useCart } from "../context/CartContext";

const CAT_LABEL = { artesanal: "Artesanal", importada: "Importada", nacional: "Nacional" };

export const BeerCard = ({ beer, index = 0 }) => {
  const { addItem } = useCart();
  const isBeer = beer.product_type === "cerveza";
  const consult = isConsult(beer);
  const sizes = beer.sizes || [];
  const [size, setSize] = useState(null);

  const add = () => {
    if (sizes.length && !size) {
      toast.error("Elige tu talla primero");
      return;
    }
    addItem(beer, 1, size);
    toast.success(`${beer.name}${size ? ` (Talla ${size})` : ""} agregada al carrito`);
  };

  return (
    <div
      className="group bg-[#171717] border border-white/10 hover:border-[#D97736]/60 transition-colors flex flex-col"
      data-testid={`beer-card-${beer.id}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#0f0f0f]">
        <img
          src={beer.image_url}
          alt={beer.name}
          loading="lazy"
          className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 bg-black/70 backdrop-blur-sm border border-white/10 px-2 py-1 overline text-[#F5A623]">
          {TYPE_LABEL[beer.product_type] || CAT_LABEL[beer.category] || beer.category}
        </span>
        <span className="absolute top-3 right-3 bg-black/70 backdrop-blur-sm px-2 py-1 text-xs font-semibold text-white">
          {isBeer ? `${beer.abv}% ABV` : beer.unit_label}
        </span>
      </div>

      <div className="p-5 flex flex-col flex-1">
        <div className="overline mb-1">{beer.style} · {beer.origin}</div>
        <h3 className="font-display text-2xl leading-tight">{beer.name}</h3>
        <p className="text-gray-400 text-sm mt-2 line-clamp-2 flex-1">{beer.description}</p>
        {sizes.length > 0 && (
          <div className="mt-4" data-testid={`sizes-${beer.id}`}>
            <div className="text-[10px] uppercase tracking-widest text-gray-500 mb-2">Tallas disponibles</div>
            <div className="flex flex-wrap gap-2">
              {sizes.map((s) => (
                <button
                  key={s}
                  type="button"
                  onClick={() => setSize(s)}
                  className={`min-w-[38px] h-8 px-2 text-xs font-semibold border transition-colors ${size === s ? "bg-[#D97736] border-[#D97736] text-black" : "border-white/20 text-white hover:border-[#D97736]"}`}
                  data-testid={`size-${beer.id}-${s}`}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="flex items-end justify-between mt-5 pt-4 border-t border-white/10">
          <div>
            <div className="text-[10px] text-gray-500 uppercase tracking-widest">{beer.unit_label || `${beer.volume_ml} ml`}</div>
            {consult ? (
              <a href={consultPriceUrl([beer.name])} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-[#25D366] hover:text-[#4ee68a] text-xs font-semibold uppercase tracking-wide mt-1 transition-colors" data-testid={`consult-price-${beer.id}`}>
                <WhatsappLogo size={18} weight="fill" /> Consulta el precio
              </a>
            ) : (
              <div className="font-display text-3xl text-white">{money(beer.price)}</div>
            )}
          </div>
          <button
            onClick={add}
            className="flex items-center gap-2 bg-[#D97736] hover:bg-[#E88D50] text-black font-semibold uppercase text-sm tracking-wide px-4 py-2.5 transition-colors hover:-translate-y-0.5"
            style={{ transitionProperty: "background-color, transform" }}
            data-testid={`add-to-cart-${beer.id}`}
          >
            <Plus size={16} weight="bold" /> Agregar
          </button>
        </div>
      </div>
    </div>
  );
};
